module.exports = __webpack_public_path__ + "LatoLatin-Semibold.ec130592e6a00b00613e.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.woff
// module chunks = styles